import React, { Component } from 'react';
import { withStyles } from '@mui/styles';
import { withTranslation } from 'react-i18next';
import IdleTimer from 'react-idle-timer';
import { COLORS } from '../../utils/Application_Constants';
import { postSendEmail } from '../../services/ProfileServices/profileService';
import UserContext from '../../contexts/userContext';
import msSalService from '../../services/msSalService';
import Logo from '../../assets/logo/locumtenens_com_logo.svg';
import { getItemCookie, clearLocalStorage } from '../../utils/helpers';

const styles = () => ({
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        background: '#FFFFFF',
        fontFamily: 'sans-serif',
        color: '#757B92',
        fontSize: '1rem',
    },
    loginContainer: {
        textAlign: 'center',
        margin: '0 auto',
        padding: '70px',
        zIndex: '1',
    },
    divOne: {
        marginBottom: '50px',
    },
    divTwo: {
        textTransform: 'uppercase',
        background: '#0076BB',
        padding: '10px 20px',
        color: 'white',
        textDecoration: 'none',
        fontWeight: 'bold',
        marginTop: '70px',
        clear: 'both',
    },
    image: {
        width: '70%',
    },
    linkSend: {
        marginBottom: '40px',
    },
    buttonClass: {
        fontWeight: '700',
        width: '50%',
        background: COLORS.DENIM,
        color: 'White',
        justifyContent: 'center',
        borderRadius: '0px',
    },
    clickableSpan: {
        fontWeight: '500',
        color: COLORS.TRUE_BLUE,
        fontSize: '16px',
        cursor: 'pointer',
        borderBottom: `1px dashed ${COLORS.TRUE_BLUE}`,
    },
    buttonLink: {
        borderBottom: `1px dashed ${COLORS.TRUE_BLUE}`,
        textDecoration: 'underline',
        textDecorationColor: '#a6c9ea',
        color: COLORS.TRUE_BLUE,
        borderTop: 0,
        borderLeft: 0,
        borderRight: 0,
        backgroundColor: 'initial',
        cursor: 'pointer',
        fontSize: '16px',
        fontWeight: '500',
        padding: 0,

        '&:hover': { textDecorationColor: COLORS.TRUE_BLUE },
    },
});

class VerificationPage extends Component {
    constructor(props, context) {
        super(props);
        this.context = context;
        this.state = {
            result: undefined,
            timeout: 1000 * 60 * 7,
            isTimedOut: false,
            action: 'verification',
        };

        this.idleTimer = null;
        this.onIdle = this.onIdle.bind(this);
    }

    componentDidMount() {
        const { account } = this.context;
        const { invitationSentDate } = this.context;
        let email;
        const tokenEmails = account.idToken.emails;
        if (tokenEmails) {
            const [userEmail] = tokenEmails;
            email = userEmail;
        }

        if (invitationSentDate === null || invitationSentDate === undefined) {
            if (localStorage.getItem('LocalStorage_EmailSent') !== 'true') {
                this.sendInitialEmail();
            }
        } else {
            localStorage.setItem('LocalStorage_EmailInvitation', 'true');
            // setLocalStorageWithExpiry('LocalStorage_EmailInvitation', 'true', 300000);
            localStorage.setItem(
                'LocalStorage_EmailInvitationToken',
                getItemCookie('msal.idtoken')
            );
            // setLocalStorageWithExpiry('LocalStorage_EmailInvitationToken', getItemCookie('msal.idtoken'), 300000);

            // localStorage.removeItem('msal.idtoken');
            msSalService.clearMSALCache();
            const resetPasswordLink = encodeURI(
                `${process.env.REACT_APP_B2C_BASE_URI}/oauth2/v2.0/authorize?p=B2C_1A_UserName_SMS&client_id=${process.env.REACT_APP_CLIENT_ID}&scope=openid&response_type=id_token&prompt=login&login_hint=${email}&state=null&nonce=defaultNonce&redirect_uri=${window.location.origin}`
            );

            this.setState({
                result: undefined,
                action: 'invitation',
                resetPasswordURL: resetPasswordLink,
            });
        }
    }

    onIdle(e) {
        console.log('user is idle', e);
        const { isTimedOut } = this.state;
        console.log(`onIdle isTimedOut ${isTimedOut}`);

        if (isTimedOut) {
            console.log('onIdle isTimedOut so Logout!!!');
            try {
                msSalService.setInitialRedirectUri();
                msSalService.logOut();
            } catch (error) {
                Error(error);
            }
        } else {
            this.idleTimer.reset();
            this.setState({ isTimedOut: true });
        }
    }

    onAction(e) {
        console.log('user did something', e);
        this.setState({ isTimedOut: false });
    }

    onActive(e) {
        console.log('user is active', e);
        this.setState({ isTimedOut: false });
    }

    sendInitialEmail = async () => {
        const { account } = this.context;

        try {
            if (account !== null && account.idToken.emails) {
                localStorage.setItem('LocalStorage_EmailSent', 'true');
                await postSendEmail(account.idToken.emails[0]).then((response) => {
                    console.log(`sendInitialEmail Response: ${response}`);

                    this.setState({
                        result: response,
                    });
                });
            }
        } catch (error) {
            console.error(error);
        }
    };

    sendEmail = async () => {
        const { account } = this.context;

        try {
            if (account !== null && account.idToken.emails) {
                await postSendEmail(account.idToken.emails[0]).then((response) => {
                    console.log(`SendEmail Response: ${response}`);
                    // Patch for TDS-2686 to maintain JobBoard Routing Information if this was used
                    const aJobboardSignedIN = localStorage.getItem('LocalStorage_JobboardSignedIN');
                    const aJobboardSignedPath = localStorage.getItem(
                        'LocalStorage_JobboardSignedINPath'
                    );
                    //
                    clearLocalStorage();
                    msSalService.clearAuthInfo();

                    // Patch for TDS-2686 to maintain JobBoard Routing Information if this was used
                    if (aJobboardSignedIN === 'true') {
                        localStorage.setItem('LocalStorage_JobboardSignedIN', aJobboardSignedIN);
                        localStorage.setItem(
                            'LocalStorage_JobboardSignedINPath',
                            aJobboardSignedPath
                        );
                    }
                    //
                    document.cookie.split(';').forEach((c) => {
                        document.cookie = `${
                            c.trim().split('=')[0]
                        }=;expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
                    });

                    this.setState({
                        result: response,
                    });
                });
            } else {
                this.setState({
                    result: false,
                });

                clearLocalStorage();
                msSalService.clearAuthInfo();
            }

            this.setState({ isTimedOut: false, timeout: 1000 * 2 * 1 });
            this.idleTimer.reset();
        } catch (error) {
            console.error(error);
        }
    };

    render() {
        const { classes, t } = this.props;
        const { result, timeout, action, resetPasswordURL } = this.state;

        if (result === true) {
            return (
                <>
                    <IdleTimer
                        ref={(ref) => {
                            this.idleTimer = ref;
                        }}
                        element={document}
                        onActive={this.onActive}
                        onIdle={this.onIdle}
                        onAction={this.onAction}
                        debounce={250}
                        timeout={timeout}
                    />
                    <div className={classes.container}>
                        <div id="login-container" className={classes.loginContainer}>
                            <img alt="LocumTenens Logo" src={Logo} className={classes.image} />
                            <h2>Please confirm email</h2>
                            <div className={classes.divOne}>
                                <p>
                                    Our records indicate that you are eligible to access advanced
                                    features on our site.
                                </p>

                                <p>
                                    To gain access to these advanced features, please verify your
                                    email. If you have not received the email verification, resend
                                    it now by clicking{' '}
                                    <button
                                        type="button"
                                        className={classes.buttonLink}
                                        href="#"
                                        onClick={this.sendEmail}
                                    >
                                        here
                                    </button>
                                    .
                                </p>

                                <p>
                                    If the problem persists, please email{' '}
                                    <a
                                        href="mailto: CustomerService@LocumTenens.com"
                                        className={classes.clickableSpan}
                                    >
                                        {' '}
                                        CustomerService@LocumTenens.com{' '}
                                    </a>{' '}
                                    or call us at{' '}
                                    <a
                                        href={t('common:INFORMATION.HELP_NUMBER_LINK')}
                                        className={classes.clickableSpan}
                                    >
                                        {t('common:INFORMATION.HELP_NUMBER')}
                                    </a>
                                    .
                                </p>
                            </div>
                        </div>
                    </div>
                </>
            );
        }

        if (result === undefined && action === 'verification') {
            return <div className={classes.container} />;
        }

        if (result === undefined && action === 'invitation') {
            window.location = resetPasswordURL;
        }

        if (result === false) {
            return (
                <>
                    <IdleTimer
                        ref={(ref) => {
                            this.idleTimer = ref;
                        }}
                        element={document}
                        onActive={this.onActive}
                        onIdle={this.onIdle}
                        onAction={this.onAction}
                        debounce={250}
                        timeout={timeout}
                    />
                    <div className={classes.container}>
                        <div id="login-container" className={classes.loginContainer}>
                            <h2>Error occurred</h2>
                            <div className={classes.divOne}>
                                <p>
                                    An error occurred and we were unable to validate your email
                                    address.
                                </p>

                                <p>
                                    If the problem persists, please email{' '}
                                    <a
                                        href="mailto: CustomerService@LocumTenens.com"
                                        className={classes.clickableSpan}
                                    >
                                        {' '}
                                        CustomerService@LocumTenens.com{' '}
                                    </a>{' '}
                                    or call us at{' '}
                                    <a
                                        href={t('common:INFORMATION.HELP_NUMBER_LINK')}
                                        className={classes.clickableSpan}
                                    >
                                        {t('common:INFORMATION.HELP_NUMBER')}
                                    </a>
                                    .
                                </p>
                            </div>
                        </div>
                    </div>
                </>
            );
        }
    }
}
VerificationPage.contextType = UserContext;
export default withTranslation()(withStyles(styles)(VerificationPage));
